<template>
    <div class="popup-complare-overlay specify-popup" >

        <div class="complare-popup-content">
            <a href="" onclick="return false" class="pop_can_compare"><img src="/img/cancel_icon.svg" loading="lazy" alt="X"></a>
            <h2 class="clr_black">VERGELIJKING</h2>
            <p class="clr_orange txt_bold het_z">HEEFT U VRAGEN? NEEM DAN CONTACT MET ONS OP</p>
            <div class="compare-content-table">

                <item v-for="(steel, key) in steels" :steel="steel" :key="steel.id" :amount="steels.length" ></item>

            </div>
        </div>
        <div class="small-print">Aan de getoonde waarden kunnen geen rechten worden ontleend en zijn indicatief.</div>
    </div>
</template>

<script>
    export default {
        props: [
            'steels'
        ],
        data: function() {
            return {
            }
        },
    }
</script>
<style>
    .popup-complare-overlay{
        overflow: auto;
        position: fixed;
    }
    .complare-popup-content{
        max-height: 100%;
        overflow-y: auto;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/steelfilter/compare/modal.vue